<template>
    <div id="hotel">
        <ImageSwiper :images="hotel.images"></ImageSwiper>

        <div class="container text-center">
            <h1 class="hotel-title">
                {{ hotelDetails.name }}
            </h1>
            <Classification
                v-if="hotelDetails.hotelClassification"
                :hotelClassification="hotelDetails.hotelClassification || {}"
                estimateBelowStars
            ></Classification>
        </div>

        <TabSwiper :tabs="tabItems">
            <!--Tab 1-->
            <template v-slot:[tabItems[0]]>
                <DetailsSection>
                    <FeatureIcons :features="hotel.hotelTags"></FeatureIcons>
                </DetailsSection>

                <DetailsSection v-if="$getSafe(hotel, 'variants.length')" no-border>
                    <template slot="header">
                        {{ $t('HotelDetails.section.products') }}
                    </template>
                    <HotelOffers :variants="hotel.variants" :hotelWebname="hotelDetails.webname"></HotelOffers>
                </DetailsSection>
            </template>
            <!--tab 2 -->
            <template v-slot:[tabItems[1]]>
                <DetailsSection v-if="hotel.description || $getSafe(hotel, 'hotelDetails.latLon')">
                    <template slot="header">
                        {{ $t('ProductDetails.section.aboutHotelAndRegion') }}
                    </template>
                    <HotelMap
                        v-if="$getSafe(hotelDetails, 'latLon.length')"
                        :center="hotelDetails.latLon"
                        :zoom="9"
                        :markers="[marker]"
                    >
                        <template v-slot:popup="slotProps">
                            <h5>{{ slotProps.entry.name }}</h5>
                            <p class="h6">{{ slotProps.entry.street }}</p>
                            <p class="h6">{{ slotProps.entry.zipcode }} {{ slotProps.entry.city }}</p>
                            <div class="text-center">
                                <a class="btn btn-info text-white" :href="slotProps.entry.routeURL" target="_blank">
                                    {{ $t('Map.button.calculateRoute') }}
                                </a>
                            </div>
                        </template>
                    </HotelMap>
                    <Description v-if="hotel.description" :description-html="hotel.description" />
                </DetailsSection>
            </template>
            <!--Tab 3-->
            <template v-slot:[tabItems[2]]>
                <DetailsSection class="font-larger">
                    <template slot="header">
                        {{ $t('HotelAddress.term.provider') }}
                    </template>
                    <HotelAddress :hotelDetails="hotelDetails"></HotelAddress>
                </DetailsSection>

                <DetailsSection
                    v-if="
                        $getSafe(hotel, 'extraServices.length') ||
                        $getSafe(hotel, 'additionalHotelInfos.length') ||
                        $getSafe(hotel, 'facilityTags.length')
                    "
                >
                    <template slot="header">{{ $t('ProductDetails.section.featuresAndAmenities') }}</template>
                    <Facilities
                        :extraServices="hotel.extraServices"
                        :additionalHotelInfos="hotel.additionalHotelInfos"
                        :facilityTags="hotel.facilityTags"
                    >
                    </Facilities>
                </DetailsSection>
            </template>
        </TabSwiper>

        <DialogSwipe direction="bottom" v-if="showShareMobile" @close="$store.commit('setShowShare', false)">
            <Share
                :title="hotelDetails.name"
                :pinterestImage="$getSafe(hotel, 'pageData.teaserImageUrl')"
                class="share-mobile"
            >
            </Share>
        </DialogSwipe>
    </div>
</template>

<script>
import ImageSwiper from '@/components/swiper/ImageSwiper';
import TabSwiper from '@/components/swiper/TabSwiper';
import DetailsSection from '@/components/DetailsSection';
import Classification from '@/components/Classification';
import FeatureIcons from '@/components/FeatureIcons';
import HotelOffers from '@/components/hotel/HotelOffers';
import Description from '@/components/Description';
import HotelMap from '@/components/map/HotelMap';
import HotelAddress from '@/components/HotelAddress';
import Facilities from '@/components/Facilities';
import Share from '@/components/Share';
import DialogSwipe from '@/components/mobile/DialogSwipe';

export default {
    name: 'HotelDetailsMobile',
    components: {
        ImageSwiper,
        DetailsSection,
        Classification,
        FeatureIcons,
        HotelOffers,
        Description,
        HotelMap,
        HotelAddress,
        Facilities,
        Share,
        TabSwiper,
        DialogSwipe
    },
    data() {
        return {
            tabItems: [
                this.$t('HotelDetails.tab.offers'),
                this.$t('HotelDetails.tab.about'),
                this.$t('HotelDetails.tab.contact')
            ]
        };
    },
    props: {
        hotel: Object,
        hotelDetails: Object,
        teaser: Object,
        marker: Object
    },
    computed: {
        showShareMobile() {
            return this.$store.state.showShareMobile && this.$store.state.ident !== 'www.animod.nl';
        }
    },
    mounted() {
        document.getElementById('animod').style.paddingTop = 0;
    },
    beforeDestroy() {
        document.getElementById('animod').style.paddingTop = '';
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';

#hotel {
    .hotel-title,
    .classification {
        font-size: 28px;
        line-height: 28px;
    }

    .hotel-title {
        font-weight: 700;
        margin-top: variables.$grid-padding;
    }

    .classification {
        justify-content: center;
        margin-bottom: 25px;
    }
}
</style>
